/**
 * Color-matching score for Huesswork. See spec §9.5.
 */
export function scoreColorGuess(deltaE) {
    const raw = (100 * (40 - deltaE)) / 38;
    return Math.round(clamp(raw, 0, 100));
}
export function verdictForDeltaE(deltaE) {
    if (deltaE <= 2)
        return "hardly_distinguishable";
    if (deltaE <= 6)
        return "very_close";
    if (deltaE <= 12)
        return "noticeably_different";
    if (deltaE <= 24)
        return "clearly_different";
    return "way_off";
}
function clamp(x, min, max) {
    return Math.min(max, Math.max(min, x));
}
//# sourceMappingURL=colorScore.js.map